export const ATTACHMENTS_FILE_PICKER_VIEW_TYPE_LIST = 1;
export const ATTACHMENTS_FILE_PICKER_VIEW_TYPE_TILE = 2;
export const ATTACHMENTS_FILE_PICKER_VIEW_TYPE_GROUPS = 3;
